import {searchFiltersPlaces} from '@adv-mt/mt-search-filters'

export const SEARCH_HEADER_PLACES = {
  SUBSCRIPTION_ADS_LIST: 'subscriptionAdsList'
}

export const SEARCH_HEADER_PLACES_DICTIONARY = {
  [SEARCH_HEADER_PLACES.SUBSCRIPTION_ADS_LIST]: searchFiltersPlaces.SUBSCRIPTION_ADS_LIST
}
